import { useState, useEffect } from "react";

const EditCustomFieldModal = ({ isOpen, onClose, onSubmit, fieldData }) => {
  const [fieldLabel, setFieldLabel] = useState(fieldData?.field_label || "");
  const [is_required, setType] = useState(fieldData?.is_required || "required"); // Default to "required"
  const [placeholder, setPlaceholder] = useState(fieldData?.placeholder || "");

  useEffect(() => {
    if (fieldData) {
      setFieldLabel(fieldData.field_label);
      setType(fieldData.is_required || "required"); // Ensure type is set correctly
      setPlaceholder(fieldData.placeholder || "");
    }
  }, [fieldData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Format the payload
    const payload = {
      field_label: fieldLabel,
      placeholder: placeholder || null,
      type: is_required, // Only include the type field
    };


    // Ensure fieldData.id is included
    const success = await onSubmit(fieldData.id, payload);

    if (success) {
      onClose(); // Close modal
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white p-6 rounded-md w-[700px]">
        <h2 className="text-lg font-semibold mb-4">Edit Custom Field</h2>
        <form className="grid gap-4" onSubmit={handleSubmit}>
          {/* Field Name */}
          <div>
            <label className="block">Field Name</label>
            <input
              type="text"
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              value={fieldLabel}
              onChange={(e) => setFieldLabel(e.target.value)}
              required
            />
          </div>

          {/* Placeholder (only for text or date fields) */}
          {fieldData?.field_type === "text" || fieldData?.field_type === "date" ? (
            <div>
              <label className="block">Placeholder</label>
              <input
                type="text"
                className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
                value={placeholder}
                onChange={(e) => setPlaceholder(e.target.value)}
              />
            </div>
          ) : null}

          {/* Required */}
          <div>
            <label className="block">Required</label>
            <select
              className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none"
              value={is_required}
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <option value="required">Required</option>
              <option value="optional">Optional</option>
            </select>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              className="bg-gray-300 text-black px-4 py-2 rounded-md"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCustomFieldModal;
